import { type DatabaseSnapshot } from '@/entities/database';
import request from '@/shared/api/request';

export const getDatabaseSnapshot = ({
  database_uuid,
  snapshot_id,
}: {
  database_uuid: string;
  snapshot_id: number;
}): Promise<{ snapshot: DatabaseSnapshot }> =>
  request({
    url: `/databases/${database_uuid}/snapshots/${snapshot_id}`,
  });
